module.exports = __webpack_public_path__ + "static/media/fieri.810760eb.png";